module.exports = __webpack_public_path__ + "static/shape-pattern2-4bd72c344fccac3b19031e7c31d42096.png";